export default __webpack_public_path__ + "static/media/HISTORY_WORLD_HISTORY.ac4446ec.svg";